type ApiTrigger = (arg: any) => { unwrap: () => Promise<any> };

// The generated v2 triggers the caller gets from its hooks.
export interface SurveyApi {
  createSurvey: ApiTrigger;
  updateSurvey: ApiTrigger;
}

const NewSurvey = async ({
  questionnaire,
  responses,
  account,
  surveyId,
  api,
  projectId,
  contactName,
  contactEmail,
}: {
  questionnaire: any;
  responses: any;
  account: any;
  surveyId: any;
  api: SurveyApi;
  projectId: any;
  contactName?: string;
  contactEmail?: string;
}) => {
  if (responses) {
    responses = responses.map((res) => {
      if (res["survey-response-id"] === null) {
        const { "survey-response-id": _omit, ...rest } = res;
        return rest;
      }
      return res;
    });
  }

  const payload = {
    data: {
      type: "surveys",
      id: undefined,
      attributes: {
        name: questionnaire.attributes.name,
        responses,
      },
      relationships: {
        account: {
          data: {
            id: account.data.attributes["account-id"],
            type: "accounts",
          },
        },
        questionnaire: {
          data: {
            id: questionnaire.id,
            type: "questionnaires",
          },
        },
      },
    },
  };

  if (surveyId) {
    payload.data.id = surveyId;
  }

  if (contactName) {
    payload.data.attributes["contact-name"] = contactName;
  }
  if (contactEmail) {
    payload.data.attributes["contact-email"] = contactEmail;
  }

  if (projectId) {
    payload.data.relationships["project"] = {
      data: {
        id: projectId,
        type: "projects",
      },
    };
  }

  try {
    const response = surveyId
      ? await api.updateSurvey({ id: String(surveyId), body: payload }).unwrap()
      : await api.createSurvey({ body: payload }).unwrap();

    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export default NewSurvey;
